import * as React from 'react';
import { Box, Button, ButtonProps, Stack, Typography } from '@mui/material';
import { Info } from 'lucide-react';

// ─── Props ────────────────────────────────────────────────────────────────────

interface CrossSellBannerProps {
  heading: string;
  body: string;
  ctaLabel: string;
  ctaProps?: ButtonProps;
  browsePlansLabel: string;
  onCta: () => void;
  onBrowse: () => void;
}

// ─── Component ────────────────────────────────────────────────────────────────

export const CrossSellBanner = ({
   heading, body, ctaLabel, browsePlansLabel, onCta, onBrowse, ctaProps = {}
}: CrossSellBannerProps) => (
  <Box sx={{
    bgcolor: '#f0fdfa', border: '1px solid rgba(0,150,137,0.2)', borderRadius: 1.5, p: 2,
  }}>
    <Stack direction="row" alignItems="flex-start" gap={1.5}>
      <Box sx={{
        p: 0.75, borderRadius: '50%', bgcolor: '#ccfbf1',
        display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, mt: 0.25,
      }}>
        <Info size={16} color="#00786f" />
      </Box>
      <Box sx={{ flex: 1 }}>
        <Typography sx={{ fontWeight: 700, fontSize: 14, color: '#00786f', mb: 0.5 }}>
          {heading}
        </Typography>
        <Typography sx={{ fontSize: 13, color: '#4b5563', mb: 2, lineHeight: 1.5 }}>
          {body}
        </Typography>
        <Stack direction="row" gap={1.5} flexWrap="wrap">
          <Button
            onClick={onCta}
            sx={{
              bgcolor: '#2563eb', color: '#fff', fontSize: 13, fontWeight: 700,
              height: 38,
              transition: 'background 150ms', '&:hover': { bgcolor: '#1d4ed8' },
            }}
            {...ctaProps}
          >
            {ctaLabel}
          </Button>
          <Button
            onClick={onBrowse}
            sx={{
              bgcolor: '#fff', color: '#00786f', fontSize: 13, fontWeight: 700,
              px: 2, py: 1, borderRadius: 1, height: 38,
              border: '1.5px solid #0096894d', cursor: 'pointer',
              transition: 'background 150ms', '&:hover': { bgcolor: 'rgba(0,120,111,0.06)' },
            }}
          >
            {browsePlansLabel}
          </Button>
        </Stack>
      </Box>
    </Stack>
  </Box>
);
